import Button, { Props as ButtonProps } from '$store/components/ui/Button.tsx'
import { Options as UseAddToCartProps, useAddToCart } from '$store/sdk/useAddToCart.ts'
import { AvailableIcons } from 'site/components/ui/Icon.tsx'
import type { ComponentChildren } from 'preact'
import { sendEvent } from 'site/sdk/analytics.ts'
import { GenericAnalyticsEvent } from 'site/components/Analytics.tsx'

export type Props = UseAddToCartProps & ButtonProps & {
    children?: ComponentChildren
    class?: string
    loading?: boolean
    icon?: {
        id: AvailableIcons
        size?: number
        width?: number
        height?: number
    }
    onClickWithoutProducts?: (e: MouseEvent) => void
    onAddToCart?: () => void
    onCloseModal?: () => Promise<void> | void
    variant: 'addToCartShelf' | 'addToCart' | 'buyTogether' | 'kitLook' | 'modalBuy'
    item_list_id?: string
    item_list_name?: string
    add_to_cart_showcase?: GenericAnalyticsEvent
    disabled?: boolean
}

function AddToCartButton({
    children,
    class: _class = '',
    loading,
    onCloseModal,
    onAddToCart,
    variant,
    item_list_id,
    item_list_name,
    add_to_cart_showcase,
    disabled,
    ...useAddToCartProps
}: Props) {
    const props = useAddToCart({ ...useAddToCartProps, item_list_id, item_list_name })

    const handleClick = (e: MouseEvent) => {
        if (useAddToCartProps.itemsToAdd.length === 0) {
            useAddToCartProps.onClickWithoutProducts?.(e)
        } else {
            props.onClick(e)
            onCloseModal?.()
            onAddToCart?.()
            if (add_to_cart_showcase) sendEvent(add_to_cart_showcase)
        }
    }

    return (
        <Button
            variant={variant}
            data-deco='add-to-cart'
            {...useAddToCartProps}
            {...props}
            onClick={handleClick}
            loading={props.loading || loading}
            class={`w-full ${_class}`}
            disabled={disabled}
        >
            {children}
        </Button>
    )
}

export default AddToCartButton
